__turbopack_context__.v({
  "dialog": "Dialog-module-scss-module__qZI4SG__dialog",
  "open": "Dialog-module-scss-module__qZI4SG__open",
  "overlay": "Dialog-module-scss-module__qZI4SG__overlay",
});
